import { RegisterCards } from './RegisterCards'
export default RegisterCards